import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Box,
} from '@mui/material';
import {
  PersonAdd as PersonAddIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  Badge as BadgeIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationOnIcon,
  Notes as NotesIcon,
  Fingerprint as FingerprintIcon,
  Receipt as ReceiptIcon,
  Business as BusinessIcon,
  SportsEsports as SportsEsportsIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../../contexto/store';
import { insertarPosibleCliente } from '../../../actions/ClientesAction';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';

const NuevoPosibleCliente = (props) => {
  const mounted = useRef(true);
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [cliente, setCliente] = useState({
    NOMBRE: '',
    APELLIDO: '',
    CI: '',
    RUC: '',
    TELEFONO: '',
    DIRECCION: '',
    EMAIL: '',
    USUARIO: '',
    OBSERVACIONES: '',
    PROFESIONORUBRO: '',
    HOBBY: '',
  });
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setCliente((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const registrarPosibleCliente = () => {
    if (cliente.APELLIDO !== '' || cliente.CI !== '') {
      const usuario = sesionUsuario.usuario.nombrecompleto;
      const objetoNuevo = {
        NOMBRE: cliente.NOMBRE,
        APELLIDO: cliente.APELLIDO,
        CI: cliente.CI,
        RUC: cliente.RUC,
        TELEFONO: cliente.TELEFONO,
        DIRECCION: cliente.DIRECCION,
        EMAIL: cliente.EMAIL,
        OBSERVACIONES: cliente.OBSERVACIONES,
        PROFESIONORUBRO: cliente.PROFESIONORUBRO,
        HOBBY: cliente.HOBBY,
        USUARIO: usuario,
        UsuarioId: sesionUsuario.usuario.id,
      };
      insertarPosibleCliente(objetoNuevo).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Se guardo con exito el posible cliente ',
            },
          });
          setCliente({
            NOMBRE: '',
            APELLIDO: '',
            CI: '',
            RUC: '',
            TELEFONO: '',
            DIRECCION: '',
            EMAIL: '',
            USUARIO: '',
            OBSERVACIONES: '',
            PROFESIONORUBRO: '',
            HOBBY: '',
          });
          let objetoAudi = {
            usuario: sesionUsuario.usuario.nombrecompleto,
            accion: 'Registro',
            panel: 'Gestion de Clientes',
            tabla: 'POSIBLESCLIENTES',
            filaafectada: 'NUEVO REGISTRO',
            UsuarioId: sesionUsuario.usuario.id,
          };
          RegistrarAccion(objetoAudi);
          volver();
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Errores al intentar guardar ',
            },
          });
        }
      });
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje:
            'Los Campos Apellidos y CI son obligatorios Asegurese de llenarlos',
        },
      });
    }
  };
  const volver = () => {
    props.history.goBack();
  };
  useEffect(() => {
    if (mounted.current) {
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, []);
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <PersonAddIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Nuevo Posible Cliente
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Registra un nuevo posible cliente en el sistema
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Información del Posible Cliente */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Información del Posible Cliente
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              name="NOMBRE"
              value={cliente.NOMBRE}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nombre"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="APELLIDO"
              value={cliente.APELLIDO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Apellido/Razón Social *"
              required
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="CI"
              value={cliente.CI}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nro. Cédula *"
              required
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <FingerprintIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="RUC"
              value={cliente.RUC}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="RUC"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <ReceiptIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="TELEFONO"
              value={cliente.TELEFONO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Teléfono"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <PhoneIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="DIRECCION"
              value={cliente.DIRECCION}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Dirección"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <LocationOnIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="EMAIL"
              value={cliente.EMAIL}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Email"
              type="email"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <EmailIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="PROFESIONORUBRO"
              value={cliente.PROFESIONORUBRO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Profesión/Rubro"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BusinessIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="HOBBY"
              value={cliente.HOBBY}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Hobby"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <SportsEsportsIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="OBSERVACIONES"
              value={cliente.OBSERVACIONES}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              label="Observaciones"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'flex-start', pt: 1.5 }}>
                    <NotesIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Botones de acción */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
        }}
      >
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={volver}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-2px)',
              boxShadow: 2,
            },
            transition: 'all 0.2s ease',
          }}
        >
          Volver
        </Button>

        <Button
          variant="contained"
          size="large"
          startIcon={<SaveIcon />}
          onClick={registrarPosibleCliente}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Registrar Posible Cliente
        </Button>
      </Box>
    </Container>
  );
};
export default NuevoPosibleCliente;
